import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const unassignedCompaniesListSlice = createSlice({
    name: 'ui/unassigned-companies-list',
    initialState: {
        ...initialState,
        filters: { ...initialState.filters, userType: 'all' },
        pureFilters: { ...initialState.pureFilters, userType: 'all' }
    },
    reducers: {
        ...listReducers,
        onResetFilters(state) {
            state.filters = { userType: 'all' }
            state.pureFilters = { userType: 'all' }
        }
    }
})

export const unassignedCompaniesListActions = unassignedCompaniesListSlice.actions
export default unassignedCompaniesListSlice.reducer
